module.exports = __webpack_public_path__ + "ff18b09c677e1b8195b908c8cd0f04fb.svg";